import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeading } from './SectionHeading';
import { MapPin, Phone, Clock, Mail } from 'lucide-react';
const contactInfo = [{
  icon: <MapPin size={32} data-id="element-15" />,
  title: 'Dirección',
  details: ['Av. Siempreviva 742', 'Neuquén Capital'],
  color: 'bg-white'
}, {
  icon: <Phone size={32} data-id="element-16" />,
  title: 'Teléfono / Urgencias',
  details: ['+54 9 299 519-2151', 'Atención 24hs para urgencias'],
  color: 'bg-secondary'
}, {
  icon: <Clock size={32} data-id="element-17" />,
  title: 'Horarios de Consultorio',
  details: ['Lunes a Viernes: 9:00 a 20:00', 'Sábados: 9:00 a 14:00'],
  color: 'bg-accent'
}, {
  icon: <Mail size={32} data-id="element-18" />,
  title: 'Email',
  details: ['hola@patitasfelices.com', 'Respondemos en el día'],
  color: 'bg-white'
}];
export const Contact: React.FC = () => {
  return <section id="contacto" className="py-24 bg-bg" data-id="element-19">
      <div className="container mx-auto px-4" data-id="element-20">
        <SectionHeading title="Encontranos fácil" subtitle="Estamos ubicados en una zona accesible, con estacionamiento propio para tu comodidad." data-id="element-21" />

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mt-16 max-w-6xl mx-auto" data-id="element-22">
          {contactInfo.map((info, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className={`${info.color} border-3 border-text rounded-3xl p-8 neo-shadow text-center flex flex-col items-center`} data-id="element-23">
              <div className="bg-white border-3 border-text rounded-full w-20 h-20 flex items-center justify-center mb-6 neo-shadow-sm transform rotate-3" data-id="element-24">
                {info.icon}
              </div>
              <h3 className="text-xl font-black mb-4" data-id="element-25">{info.title}</h3>
              <div className="font-medium text-gray-800 space-y-1" data-id="element-26">
                {info.details.map((detail, i) => <p key={i} data-id="element-27">{detail}</p>)}
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
};